import { Box, Typography } from '@mui/material'
import { useScrollIntoView } from 'src/hooks/useScrollIntoView'
import { useInView } from 'react-intersection-observer'
import clsx from 'clsx'
import { Link } from '.'

type WhyScsProps = {
    link: Link
}

const WhyScs = ({ link }: WhyScsProps) => {
    const { ref: intersectionRef, inView } = useInView({
        threshold: 1,
        triggerOnce: true
    })

    useScrollIntoView(link)
    const pointers = [
        'No Minimum Deposit Requirement',
        'No minimum or Hidden Fees',
        'Dedicated & Knowledgeable Case Manager',
        'No Minimum Balance Requirement'
    ]
    return (
        <Box ref={intersectionRef}>
            <Box
                ref={link.componentRef}
                className="mx-20 mb-16 flex items-center justify-between rounded-[40px] bg-[#BDC5E7] p-[50px] ltb_1300:px-12 tbmd_1000:flex-col tbmd:mx-5 tbmd:mb-8 tbmd:gap-8 tbmd:px-6"
            >
                <Box>
                    <Typography className="font-[Barlow] text-[24px] font-semibold text-[#242C4E]">Why Choose</Typography>
                    <Typography className="font-[Barlow] text-[40px] font-bold text-[#242C4E] tbmd:text-[29px]">SCS Trust Services?</Typography>
                    <Box className="mt-8 flex flex-col gap-4">
                        {pointers.map((pointer) => (
                            <Box className="w-[574px] rounded-[14px] bg-[#EEF1F9] p-5 tbmd:w-auto" key={pointer}>
                                <Typography className="text-[#242C4E]">{pointer}</Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
                <Box className="relative items-center gap-3 tb:flex tb:flex-col-reverse tbmd_1000:hidden">
                    <img
                        className={`${clsx({
                            'animate__animated animate__fadeInUp': inView,
                            hidden: !inView
                        })} absolute left-[-35px] bottom-8 z-10 h-auto ltb_1400:left-4 ltb_1400:w-[150px] ltb_1300:w-[115px] tb:static`}
                        src="/images/servedAccountsNum.png"
                        alt="agreement"
                    />
                    <img
                        className={`${clsx({ 'animate__animated animate__fadeInDown': inView, hidden: !inView })} h-auto max-w-full`}
                        src="/images/agreement.png"
                        alt="agreement"
                    />
                </Box>
                <img className="hidden tbmd_1000:block" src="/images/agreement-mobile.png" alt="agreement" />
            </Box>
        </Box>
    )
}

export default WhyScs
